exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.community-button_community-button_20Q0O {\r\n    box-shadow: 0 0 0 1px var(--ui-black-transparent);\r\n}\r\n\r\n.community-button_community-button-icon_WReZ5 {\r\n    height: 1.25rem;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"community-button": "community-button_community-button_20Q0O",
	"communityButton": "community-button_community-button_20Q0O",
	"community-button-icon": "community-button_community-button-icon_WReZ5",
	"communityButtonIcon": "community-button_community-button-icon_WReZ5"
};